import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FloorPlanListItemComponent} from './components/floor-plan-list-item/floor-plan-list-item.component';
import {FloorListComponent} from './components/floor-list/floor-list.component';
import {DeviceMarkerTooltipComponent} from './components/device-marker-tooltip/device-marker-tooltip.component';
import {IconModule} from '../vision/icon';
import {CanvasMapComponent} from './components/canvas-map/canvas-map.component';
import {ButtonModule} from '../vision/button';
import {DropdownModule} from '../vision/dropdown';

@NgModule({
  imports: [
    CommonModule,
    IconModule,
    ButtonModule,
    DropdownModule
  ],
  exports: [
    FloorListComponent,
    FloorPlanListItemComponent,
    DeviceMarkerTooltipComponent,
    CanvasMapComponent
  ],
  declarations: [
    FloorListComponent,
    FloorPlanListItemComponent,
    DeviceMarkerTooltipComponent,
    CanvasMapComponent
  ]
})

export class FloorPlanSharedModule {
}
